export const PRICE_SPEC = 'https://schema.org/PriceSpecification';
export const PRICE_ITEM = 'price';
export const CURRENCY_ITEM = 'priceCurrency';
